function ModuleHero() {
  return (
    <div className="relative pt-20 pb-16 bg-gradient-to-br from-[#1A3A2E] to-[#0F2419]">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2339FF14' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#39FF14]/20 px-4 py-2 rounded-full mb-6">
          <i className="ri-book-2-line text-[#39FF14]"></i>
          <span className="text-[#39FF14] text-sm font-semibold">Módulo 3</span>
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Metodologías de Entrenamiento
        </h1>

        <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
          Análisis completo y objetivo de los principales sistemas de entrenamiento: Weider, Heavy Duty, HIT, PPL, Full Body, Upper/Lower y periodización. Aprende a seleccionar y aplicar la metodología adecuada según tu perfil y objetivos.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm">
          <div className="flex items-center gap-2 text-gray-300">
            <i className="ri-file-list-3-line text-[#39FF14] text-lg"></i>
            <span>9 Lecciones Completas</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <i className="ri-time-line text-[#39FF14] text-lg"></i>
            <span>Análisis Comparativo</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <i className="ri-checkbox-circle-line text-[#39FF14] text-lg"></i>
            <span>Casos Prácticos</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModuleHero;